<template>
  <v-card outlined class="mt-5">
    <v-stepper v-model="step" vertical class="elevation-0">
      <v-stepper-step :complete="step > 1" step="1">
        Address You Are Applying for
      </v-stepper-step>
      <v-stepper-content step="1">
        <LeaseInfo @step="move" />
      </v-stepper-content>
      <v-stepper-step :complete="step > 2" step="2">
        Applicant Info
      </v-stepper-step>
      <v-stepper-content step="2">
        <Personalinfo @step="move" />
      </v-stepper-content>
      <v-stepper-step :complete="step > 3" step="3">
        Address History
      </v-stepper-step>
      <v-stepper-content step="3">
        <Address @step="move" />
      </v-stepper-content>
      <v-stepper-step :complete="step > 4" step="4">
        Employment & Income
      </v-stepper-step>
      <v-stepper-content step="4">
        <Employment @step="move" />
      </v-stepper-content>
      <v-stepper-step :complete="step > 5" step="5">
        Review & Sign
      </v-stepper-step>
      <v-stepper-content step="5">
        <Signature @step="move" />
      </v-stepper-content>
      <v-stepper-step :complete="step > 6" step="6">
        Pay & Submit
      </v-stepper-step>
      <v-stepper-content step="6">
        <Payment @step="move" />
      </v-stepper-content>
    </v-stepper>
  </v-card>
</template>

<script>
import Personalinfo from "./PersonalInfo";
import Signature from "./Signature";
import Payment from "./Payment.vue";
import Address from "./Address";
import Employment from "./Employment";
import LeaseInfo from "./LeaseInfo";
export default {
  components: {
    Personalinfo,
    Signature,
    LeaseInfo,
    Payment,
    Address,
    Employment,
  },
  data() {
    return {
      step: 1,
    };
  },
  methods: {
    move(val) {
      this.step = val;
    },
  },
};
</script>

<style></style>
